import { Link } from "react-router-dom";
import logoMain from "@/assets/brand/stayguide-logo-main.png";
import symbolImg from "@/assets/brand/stayguide-symbol.png";

export function Logo({ className = "h-10", to = "/", link = true }) {
  const img = (
    <img src={logoMain} alt="StayGuide" className={`${className} w-auto select-none`} draggable="false" />
  );
  return link ? (
    <Link to={to} aria-label="StayGuide" data-testid="brand-logo" className="inline-flex items-center shrink-0">{img}</Link>
  ) : img;
}

export function LogoSymbol({ className = "h-7" }) {
  return <img src={symbolImg} alt="StayGuide" data-testid="brand-symbol" className={`${className} w-auto object-contain select-none`} draggable="false" />;
}
